<template>
    <div class="mt-4 mb-2" style="background-color: rgb(255, 255, 255);">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <div v-if="!loading">
            <div class="pa-3" v-if="!scans.length">
                No attendance scans.
            </div>
            <div class="" v-if="scans.length" v-for="(scan, index) in scans">
                <div class="layout row mb-2 px-3">
                    <!-- <v-icon class="mr-2" dark :color="getStatusIconColor(call)">{{
                    getStatusIcon(call)
                }}</v-icon> -->
                    <div class=" font-weight-medium mr-3">Date:</div>
                    <div class="mr-3">{{ scan.scanDate | time }}</div>
                    <div class="font-weight-medium mr-3">
                        Card Number:
                    </div>
                    <div class="mr-3">{{ scan.cardNum }}</div>
                    <div class="font-weight-medium mr-3">
                        Device ID:
                    </div>
                    <div class="mr-3">{{ scan.deviceID }}</div>
                    <div class="font-weight-medium mr-3" v-if="scan.points">
                        Points:
                    </div>
                    <div class="mr-3" v-if="scan.points">{{ scan.points }}</div>

                    <div class="font-weight-medium mr-3" v-if="scan.enteredBy">
                        Entered By:
                    </div>
                    <div class="mr-3">{{ scan.enteredBy }}</div>
                    <div class="font-weight-medium mr-3" v-if="scan.note">
                        Note:
                    </div>
                    <div class="mr-3">{{ scan.note }}</div>
                </div>
                <v-divider
                    class="py-2 mb-1"
                    v-if="index + 1 < scans.length"
                ></v-divider>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            scans: [],
            loading: true,
        };
    },
    async created() {
        await this.loadScans();
    },
    computed: {},
    methods: {
        async loadScans() {
            const scans = await this.$http.get(
                "api/attendanceScans/getScans?studentID=" + this.row.studentID,
            );

            this.scans = scans;

            this.loading = false;
        },
    },
};
</script>
<style>
.other-calls-detail-text {
    font-size: 16px;
    font-weight: 400;
}
.callback-request-status-pending {
    background-color: #fdb400;
}
.callback-request-status-completed {
    background-color: #4caf50;
}
</style>
